<template>
    <label v-if="titleElement" :class="titleClass" :for="id">
        <b>
            {{ titleElement }}
        </b>
        <b class="text-danger ms-1" v-if="isRequired">*</b>
    </label>

    <div :class="onHasIcon">
        <span v-if="iconDir === 'left'" class="input-group-text" :class="classIcon">
            <i :class="onGetIcon"></i>
        </span>

        <input
            type="text"
            class="form-control vf-input"
            :class="totalyClass"
            :name="name"
            :id="id"
            :placeholder="placeholder"
            :value="modelValue"
            :disabled="disabled"
            :ref="id"
            :valid="valid"
            @input="onUpdateModelValue"
            @keyup="onChange"
            :data-automation="`input-${ id }`"
        />

        <span v-if="iconDir === 'right'" class="input-group-text" :class="classIcon">
            <i :class="onGetIcon"></i>
        </span>
    </div>

    <span v-if="textBelow" :class="classBelow">{{ textBelow }}</span>
</template>

<script>
    import { onMounted, watch } from 'vue';
    import { formProps } from '@/mixins';
    import { useVFInput } from '@/composables';

    export default {
        name: 'VFInputText',
        mixins: [
            formProps
        ],
        setup(props, { emit }) {
            const {
                totalyClass,
                valid,
                onGetClasses,
                onGetIcon,
                onHasIcon,
                onUpdateModelValue,
                clearError
            } = useVFInput(props, emit);

            
            watch(() => valid.value, (newValue) => {
                totalyClass.value = onGetClasses(newValue);
            });

            onMounted(()=>{
                totalyClass.value = onGetClasses(valid.value);
            });

            const onChange = (event) => {
                emit('keyup', event.target.value); // Emitimos el evento change con el valor actualizado
            };


            return {
                totalyClass,
                valid,
                onGetIcon,
                onHasIcon,
                onChange,
                onUpdateModelValue,
                clearError
            };
        }
    };
</script>